import React from 'react';
import ProLink from '../ProLink/ProLink';
import ArrowDownIcon from '../SonyIcon/icons/ArrowDownIcon';
import { miniGazelle } from '../../../helpers';

import './ExpandableList.scss';

const styles = {
    position: 'relative',
    top: '6px',
    left: '20px',
    fontSize: '20px'
};

export default class ExpandableList extends React.Component {
    state = {
        allItems: [],
        items: [],
        expanded: false,
        originalLength: 0
    };

    componentWillMount() {
        this.prepareItems();
    }

    componentWillReceiveProps(nextProps) {
        this.prepareItems(nextProps);
    }

    prepareItems = () => {
        const { items, listSize } = this.props;

        const allItems = items;
        const originalLength = allItems.length;

        this.setState({
            allItems,
            items: listSize ? items.slice(0, listSize) : items,
            originalLength
        });
    };

    showAllItems = ev => {
        ev.preventDefault();
        const { allItems } = this.state;

        this.setState({ items: allItems, expanded: true });
    };

    renderItem = (item, index) => {
        const { logicalName } = this.props;

        if (!item.url && !item.targetLink) {
            return (
                <div key={`${logicalName}-${index}`} className="item">
                    {item.title}
                </div>
            );
        }

        return item.url && !!item.url.length ? (
            <div className="item link tw-mb-1" key={`${logicalName}-${index}`}>
                <ProLink to={item.url}>{item.title}</ProLink>
            </div>
        ) : (
            <div className="item link tw-mb-1" key={`${logicalName}-${index}`}>
                <ProLink to={item.targetLink}>{item.title}</ProLink>
            </div>
        );
    };

    render() {
        /* standard props */
        const { title, icon, listSize, logicalName: id } = this.props || {};

        /**
         * standard props used in the style / function of the module.
         * Null if not specified
         **/
        const logicalName = id || null;

        /**
         * props specific to this module
         **/
        const { items, expanded, originalLength } = this.state;

        return (
            <div className="tw-bg-grey important-information" id={logicalName}>
                <div className="container tw-mx-auto">
                    <div className="md:tw-flex tw-gap-10 tw-w-full">
                        <div className="md:tw-w-1/12 tw-mb-5">{icon}</div>
                        <div className="ml-auto md:tw-w-10/12 tw-w-full">
                            <div>
                                <h2>{title}</h2>
                                {items.map((item, index) => {
                                    return this.renderItem(item, index);
                                })}
                            </div>

                            {!expanded && originalLength > listSize && listSize && (
                                <div className="expand">
                                    <ProLink to="#expand" onClick={this.showAllItems}>
                                        {miniGazelle.label('moreResults', true)}
                                        <ArrowDownIcon style={styles} />
                                    </ProLink>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
